import _ from 'lodash'
import { Map, isImmutable } from 'immutable'
import { processWidgetCustomSFItem } from './processWidgetCustomSFItem'
import { isHaveSFMappingActionGet } from './isHaveSFMappingActionGet'
import { getParams, getState } from '../../lib/processPortalRules'

export const processWidgetCustomSFGet = (state, conf, isPortal) => async (dispatch) => {
  let sfMapping = state.getIn(['project', 'Settings', 'sfMapping'], Map())

  if (isImmutable(sfMapping)) {
    sfMapping = sfMapping.toJS()
  }

  const widgetsData = getState(state)

  let hashCustomActions
  let isHaveMapping = isHaveSFMappingActionGet(conf, sfMapping)
  if (conf.isBulk) {
    hashCustomActions = {}
    _.each(conf.list, function (sfItem) {
      if (sfItem) {
        hashCustomActions[sfItem.value] = {
          ...sfItem,
          runInBackground: conf.runInBackground,
          isVerifyCaptcha: conf.isVerifyCaptcha,
          widgetPath: conf.widgetPath,
        }
      }
    })
  } else {
    hashCustomActions = {
      [conf.value]: conf,
    }
  }

  const params = getParams(state)
  if (isHaveMapping) {
    await processWidgetCustomSFItem(
      sfMapping,
      state,
      conf,
      widgetsData,
      params,
      hashCustomActions,
      dispatch,
      null,
      isPortal
    )
  }
}
